import { lazy } from 'react';

import { retry } from 'src/utils/routing';
import { guidelinesPageStore } from './store';


export default {
    name: 'guidelines',
    path: '/guidelines/:auditionId',
    secured: true,
    component: () => lazy(() => retry(() => import('./index.js'))),
    activate: (info) => {
        const { auditionId } = info.route.params;
        guidelinesPageStore.getAuditionData(auditionId);
    }
};
